import "../styles/testimonials.css";
import TestimonialCard from "./TestimonialCard";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Maria Sanchez",
      rating: 5,
      img: "/img/maria-sanchez.jpg",
      comment:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    },
    {
      name: "Anthony Clifton",
      rating: 5,
      img: "/img/anthony-clifton.jpg",
      comment:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    },
    {
      name: "Tamika Jackson",
      rating: 4,
      img: "/img/tamika-jackson.jpg",
      comment:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    },
    {
      name: "Brandon Ming",
      rating: 4,
      img: "/img/brandon-ming.jpg",
      comment:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    },
  ];
  return (
    <section className="testimonials">
      <div className="testimonials-container">
        <h2>What people say about us!</h2>
        {testimonials.map((testimonial) => (
          <TestimonialCard key={testimonial.name} testimonial={testimonial} />
        ))}
      </div>
    </section>
  );
};

export default Testimonials;
